module.exports = __webpack_public_path__ + "assets/img/10.4fd47129.png";